module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kc-Lb.0a494f31.png";